import styled from "styled-components";

export const StyledContainer = styled.div`
  padding: 1em 2em;
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 1000px) {
    margin-bottom: 12.93rem;
  }
`;

export const HeaderContainer = styled.div``;

export const EyeCatcherContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
`;

export const CallContainer = styled.div`
  margin: 7em 0 2em;
`;
